export type EmailListSortBy = 'date' | 'receivedDate' | 'partitionAt';

const STORAGE_KEY = 'ums-email-list-sort-v1';

export const EMAIL_LIST_SORT_OPTIONS: ReadonlyArray<{ value: EmailListSortBy; label: string; hint: string }> = [
  { value: 'date', label: 'Message date', hint: 'Date: header (when sent)' },
  { value: 'receivedDate', label: 'Received date', hint: 'When the server synced this copy' },
  { value: 'partitionAt', label: 'Archive date', hint: 'Indexed date (header, or received if missing)' },
] as const;

export function isEmailListSortBy(value: string): value is EmailListSortBy {
  return value === 'date' || value === 'receivedDate' || value === 'partitionAt';
}

export function loadEmailListSort(): EmailListSortBy {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && isEmailListSortBy(raw)) return raw;
  } catch {
    /**/
  }
  return 'date';
}

export function saveEmailListSort(sortBy: EmailListSortBy): void {
  try {
    localStorage.setItem(STORAGE_KEY, sortBy);
  } catch {
    /**/
  }
}

export function emailListSortLabel(sortBy: EmailListSortBy): string {
  return EMAIL_LIST_SORT_OPTIONS.find((o) => o.value === sortBy)?.label ?? 'Message date';
}

export function emailDisplayDateForSort(
  email: { date: string; receivedDate: string; partitionAt?: string },
  sortBy: EmailListSortBy,
): string {
  if (sortBy === 'receivedDate') return email.receivedDate;
  if (sortBy === 'partitionAt' && email.partitionAt) return email.partitionAt;
  return email.date;
}
